

























































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import axios from "axios";

interface IhtiyatiHacizRecord {
  tarih: string;
  ihtiyati_haciz_masrafi: number | null;
  ihtiyati_haciz_vekalet_ucreti: number | null;
}

@Component
export default class IhtiyatiHaciz extends Vue {
  // Arama ve yükleme
  search: string = "";
  loading: boolean = false;
  hacizler: IhtiyatiHacizRecord[] = [];
  hacizHeaders = [
    { text: "Tarih", value: "tarih" },
    { text: "İhtiyati Haciz Masrafı", value: "ihtiyati_haciz_masrafi" },
    { text: "İhtiyati Haciz Vekalet Ücreti", value: "ihtiyati_haciz_vekalet_ucreti" },
    { text: "İşlemler", value: "actions", sortable: false, align: "right" }
  ];

  // Form ve dialog durumları
  formValid: boolean = false;
  editHacizDialog: boolean = false;
  isEditing: boolean = false;
  dateDialog: boolean = false;
  tempDate: string | null = null;
  formError: string | null = null;
  haciz: IhtiyatiHacizRecord = {
    tarih: "",
    ihtiyati_haciz_masrafi: null,
    ihtiyati_haciz_vekalet_ucreti: null
  };

  // Kurallar
  rules = {
    tarih: [
      (v: any) => !!v || "Tarih zorunludur.",
      (v: string) => /^\d{4}-\d{2}-\d{2}$/.test(v) || "Format YYYY-MM-DD olmalı."
    ],
    ihtiyati_haciz_masrafi: [
      (v: any) => (v !== null && v !== "") || "İhtiyati haciz masrafı zorunludur.",
      (v: any) => (v === null || Number(v) >= 0) || "Negatif olamaz."
    ],
    ihtiyati_haciz_vekalet_ucreti: [
      (v: any) => (v !== null && v !== "") || "İhtiyati haciz vekalet ücreti zorunludur.",
      (v: any) => (v === null || Number(v) >= 0) || "Negatif olamaz."
    ]
  };

  @Watch("haciz.tarih")
  onTarihInput(val: string) {
    if (!val) return;
    const numericVal = val.replace(/[^0-9]/g, "");
    let formatted = numericVal;

    if (numericVal.length > 4) {
      formatted = `${numericVal.slice(0, 4)}-${numericVal.slice(4)}`;
    }
    if (numericVal.length > 6) {
      formatted = `${numericVal.slice(0, 4)}-${numericVal.slice(4, 6)}-${numericVal.slice(6, 8)}`;
    }

    // Limit to YYYY-MM-DD format
    formatted = formatted.substring(0, 10);

    if (val !== formatted) {
      this.haciz.tarih = formatted;
    }
  }

  applyDate() {
    this.haciz.tarih = this.tempDate || "";
    this.dateDialog = false;
  }

  clearDate() {
    this.tempDate = "";
    this.haciz.tarih = "";
  }

  mounted() {
    this.loadIhtiyatiHaciz();
  }

  loadIhtiyatiHaciz() {
    this.loading = true;
    axios
        .get(this.$store.state.icwApiUrl + "admin/ihtiyati-hacizler")
        .then((response) => {
          if (response.data && Array.isArray(response.data)) {
            this.hacizler = response.data;
          } else if (response.data && Array.isArray(response.data.data)) {
            this.hacizler = response.data.data;
          } else {
            console.error("Beklenmeyen API yanıt formatı:", response.data);
            this.hacizler = [];
          }
        })
        .catch((error) => {
          console.error("İhtiyati Haciz kayıtları yüklenirken hata oluştu:", error);
        })
        .finally(() => {
          this.loading = false;
        });
  }

  addHaciz() {
    this.isEditing = false;
    this.resetHacizForm();
    this.editHacizDialog = true;
    this.$store.state.icwApiUrl + "admin/ihtiyati-hacizler";
  }

  editHaciz(item: IhtiyatiHacizRecord) {
    this.isEditing = true;
    // Düzenleme için mevcut kaydı kopyalıyoruz.
    this.haciz = { ...item };
    this.editHacizDialog = true;
  }

  closeHacizDialog() {
    this.editHacizDialog = false;
  }

  resetHacizForm() {
    this.haciz = {
      tarih: "",
      ihtiyati_haciz_masrafi: null,
      ihtiyati_haciz_vekalet_ucreti: null
    };
    this.formError = null;
    this.dateDialog = false;
    this.tempDate = null;
  }

  async submitHaciz() {
    const form = this.$refs.hacizForm as any;
    if (form.validate()) {
      if (this.isEditing) {
        // Düzenleme modunda: mevcut kaydı yerelde güncelle.
        const index = this.hacizler.findIndex((item) => item.tarih === this.haciz.tarih);
        if (index !== -1) {
          this.hacizler.splice(index, 1, { ...this.haciz });
        }
        this.editHacizDialog = false;
        this.resetHacizForm();
        return;
      }

      // Yeni kayıt ekleme: API'ye POST at
      try {
        this.loading = true;
        await axios.post(
          this.$store.state.icwApiUrl + "admin/ihtiyati-haciz",
          {},
          {
            params: {
              tarih: this.haciz.tarih,
              ihtiyati_haciz_masrafi: this.haciz.ihtiyati_haciz_masrafi,
              ihtiyati_haciz_vekalet_ucreti: this.haciz.ihtiyati_haciz_vekalet_ucreti,
            },
          }
        );

        // Başarılı olursa listeyi tazele ve formu kapat
        await this.loadIhtiyatiHaciz();
        this.editHacizDialog = false;
        this.resetHacizForm();
      } catch (error) {
        console.error("İhtiyati Haciz kaydı oluşturulurken hata oluştu:", error);
        this.formError = "Kayıt sırasında bir hata oluştu. Lütfen tekrar deneyin.";
      } finally {
        this.loading = false;
      }
    } else {
      console.log("Form geçerli değil.");
    }
  }
}
